import Modal from "../_bootstrapModalExtensions";
import * as Filter from '../components/filterGroup';

$(() => {
    let submitFinalizeProcessActionButton = $('#finalizeProcessActionSubmit');

    if (submitFinalizeProcessActionButton.length > 0) {

        submitFinalizeProcessActionButton.on('click', event => {
            var documentCount = submitFinalizeProcessActionButton.data('document-count');
            var verifyDocumentCount = submitFinalizeProcessActionButton.data('verify-document-count');
            var onSubmitConfirmationText = submitFinalizeProcessActionButton.data('onsubmit-confirmation-text');

            if (!canProceed(verifyDocumentCount, documentCount, onSubmitConfirmationText)) {
                event.preventDefault();
            }
        });

        loadLazyGridviews();

        Filter.Init();
    }
});

function loadLazyGridviews() {
    let grid = window['AddresseeListPartial'];
    grid.Refresh();

    grid = window['uploadedDocs'];
    grid.Refresh();
}

function canProceed(verifyDocumentCount: boolean, documentCount: number, onSubmitConfirmationText: string): boolean {
    let canProceed: boolean = true;

    if (verifyDocumentCount && documentCount == 0) {
        canProceed = Modal.showConfirmationWindow('Biztos benne, hogy nem csatol dokumentumokat az irathoz?');
    }

    if (canProceed && onSubmitConfirmationText) {
        canProceed =  Modal.showConfirmationWindow(onSubmitConfirmationText);
    }

    return canProceed;
}
